import { triggerPointsTypes } from 'common/constants/booking';

export const getTriggerPointOptions = t => [
  {
    value: triggerPointsTypes.CREATED,
    text: t('cms:cms.property.commission.trigger_point.created'),
  },
  {
    value: triggerPointsTypes.COMPLETED,
    text: t('cms:cms.property.commission.trigger_point.completed'),
  },
];
